import { BlockType } from '../../types/index.js';
import { AlertBlock as Component } from './Block.js';
export const RegisteredAlertBlock = (_intl) => ({
    recommendedName: 'Alert',
    Component,
    config: {
        type: BlockType.BuildingBlock,
    },
});
//# sourceMappingURL=registered.js.map